import { useConfigInputs, useExecCtx, useMetricsOverlay } from 'shared/state/configContexts';
import type { SectionStatus } from 'shared/state/sectionStatusContext';

/** CONF-212 exec Custom Metrics, V2 placement. All state is the classic
 *  hooks' (useExecMetrics / useDisplayMetrics, wired once in ConfigProvider);
 *  this only selects what the section needs. The panel's Current column is the
 *  REAL computed figure (`baselineMetrics`), never the display one, exactly as
 *  App.js passes `baselineMetrics={metrics}` to ExecMetricsView. */
export function useCustomMetricsSection() {
  const { config } = useConfigInputs();
  const { execMetrics } = useExecCtx();
  const { baselineMetrics, staleKeys } = useMetricsOverlay();

  const count = execMetrics.changeCount;
  const stale = Object.keys(execMetrics.overrides).filter((k) => staleKeys.has(k)).length;
  const summary = count === 0
    ? 'No overrides'
    : `${count} override${count === 1 ? '' : 's'}${stale > 0 ? ` · ${stale} stale` : ''}`;
  // 'none' when untouched: an exec who never opens this is not "missing" anything.
  const status: SectionStatus = count === 0 ? 'none' : stale > 0 ? 'warn' : 'ok';

  return { execMetrics, baselineMetrics, config, staleKeys, summary, status };
}
